export default "__VITE_ASSET__DMo6qP0D__"